import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnavimumbai() {



const cardData =
{
  keyword: 'Cab Service in Navi Mumbai',

  heading: 'Lotus Cab: Cab Service in Navi Mumbai',

headingDescription:
    "Lotus Cabs provides reliable and affordable Cab Service in Navi Mumbai for local travel, airport transfers, corporate transportation, railway station pickups, hotel transfers, business meetings, employee transportation, family outings, sightseeing tours, outstation trips, and one-way or round-trip journeys. We offer a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking assistance, transparent pricing, doorstep pickup across Navi Mumbai, well-maintained vehicles, GPS-enabled rides, and a strong commitment to safety, punctuality, and customer satisfaction, Lotus Cabs ensures a comfortable, convenient, and hassle-free travel experience for individuals, families, tourists, and corporate clients.",


  top: 'Top Places to Visit in Navi Mumbai with Lotus Cab',

 topPlaces: [
    {
        title: "Navi Mumbai International Airport (NMIA)",
        description:
            "Navi Mumbai International Airport is one of India's newest aviation hubs and a major destination for business and leisure travelers. Lotus Cabs provides reliable airport transfers with flight tracking, timely pickups, professional chauffeurs, and comfortable vehicles, ensuring a seamless journey to and from NMIA. Whether you are catching an early morning flight or arriving late at night, our airport cab service guarantees punctuality and complete peace of mind."
    },
    {
        title: "Belapur",
        description:
            "CBD Belapur is the administrative and commercial heart of Navi Mumbai, home to corporate offices, government buildings, business centers, hotels, and shopping destinations. Lotus Cabs offers dependable taxi services to Belapur for office commuters, business meetings, railway station transfers, and local sightseeing with comfortable vehicles and experienced drivers."
    },
    {
        title: "Vashi",
        description:
            "Vashi is one of the busiest commercial and residential areas in Navi Mumbai, known for Inorbit Mall, APMC Market, corporate offices, educational institutions, and excellent connectivity. Whether you need a local taxi, corporate cab, or airport transfer, Lotus Cabs provides safe, affordable, and reliable transportation throughout Vashi and nearby locations."
    },
    {
        title: "Kharghar",
        description:
            "Kharghar is a rapidly developing suburb famous for Central Park, ISKCON Temple, Golf Course, educational institutions, and premium residential communities. Lotus Cabs offers convenient cab services for daily commuting, sightseeing, corporate travel, and family outings, ensuring a comfortable travel experience across Kharghar."
    },
    {
        title: "Nerul",
        description:
            "Nerul is a vibrant locality known for DY Patil Stadium, Nerul Lake, shopping centers, business hubs, and residential neighborhoods. Lotus Cabs provides prompt and reliable taxi services in Nerul for airport transfers, railway station pickups, office travel, medical appointments, and local transportation with professional chauffeurs."
    },
    {
        title: "Airoli",
        description:
            "Airoli has emerged as one of Navi Mumbai's leading IT and business hubs, housing major technology companies, corporate offices, and residential complexes. Lotus Cabs offers comfortable and punctual cab services for corporate employees, business travelers, and families traveling within Navi Mumbai or to nearby cities."
    },
    {
        title: "Panvel",
        description:
            "Panvel serves as an important transportation gateway connecting Navi Mumbai to Pune, Goa, and the Konkan region. With its railway station, upcoming airport connectivity, and growing commercial importance, Panvel witnesses significant daily travel. Lotus Cabs provides local and outstation taxi services with safe, convenient, and affordable transportation."
    },
    {
        title: "Pune",
        description:
            "Pune is one of the most frequently booked outstation destinations from Navi Mumbai for business, education, family visits, and tourism. Lotus Cabs offers one-way and round-trip cab services via the Mumbai–Pune Expressway with comfortable vehicles, experienced drivers, and transparent pricing for a smooth highway journey."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a favorite weekend destination famous for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, and lush green valleys. Travelers from Navi Mumbai regularly choose Lotus Cabs for relaxing road trips, enjoying scenic drives through the Western Ghats in safe and well-maintained vehicles."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of Maharashtra's most important pilgrimage destinations and welcomes millions of Sai Baba devotees every year. Lotus Cabs offers comfortable Navi Mumbai to Shirdi taxi services for one-way, round-trip, and customized pilgrimage packages, ensuring a peaceful, safe, and memorable spiritual journey for every traveler."
    }
],

  "services": [
    {
      "name": "Cab Service in Navi Mumbai",
      "description": "Book cab service in Navi Mumbai for local city travel, daily commuting, corporate meetings, shopping trips, and social events. AC sedan, Ertiga, SUV, and Innova Crysta vehicles are available with professional chauffeurs familiar with Vashi, Airoli, Nerul, Kharghar, CBD Belapur, and Ghansoli routes. Transparent taxi fare structure ensures clear pricing without hidden charges. Hourly rental, full-day booking, and point-to-point rides are available. Suitable for family travel, office commutes, and emergency rides with 24x7 availability."
    },
    {
      "name": "Airport Cab Service Navi Mumbai",
      "description": "Reliable airport cab service from Navi Mumbai to Mumbai Airport (T1 & T2) ensuring timely pickup and drop. Professional drivers monitor traffic conditions to avoid delays. Spacious vehicles provide comfortable luggage accommodation. Transparent pricing includes toll and parking details."
    },
    {
      "name": "Outstation Cab Service Navi Mumbai",
      "description": "Outstation cab service in Navi Mumbai available for Pune, Nashik, Lonavala, Shirdi, Goa, Surat, and other intercity destinations. One-way and round-trip options available. Per kilometer pricing ensures clear billing."
    },
    {
      "name": "One Way Cab Navi Mumbai",
      "description": "Affordable one way cab service for travelers who do not require return booking. Pay only for one-side distance with clear fare estimation."
    },
    {
      "name": "Round Trip Taxi Navi Mumbai",
      "description": "Round trip taxi booking for business travel, weekend getaways, and family visits with flexible return timing."
    },
    {
      "name": "Corporate Cab Service Navi Mumbai",
      "description": "Professional corporate cab service for daily office commute, meetings, and client visits in Navi Mumbai."
    },
    {
      "name": "Wedding Cab Service Navi Mumbai",
      "description": "Luxury and spacious cab service for wedding events and special occasions ensuring punctual arrival."
    },
    {
      "name": "Cheap Cab Service Navi Mumbai",
      "description": "Budget-friendly taxi options available for local and outstation travel without compromising safety or comfort."
    }
  ],

  "tableData": [
    ["Cab Service in Navi Mumbai", "Airport Cab Service Navi Mumbai"],
    ["Outstation Cab Service Navi Mumbai", "One Way Cab Navi Mumbai"],
    ["Round Trip Taxi Navi Mumbai", "Corporate Cab Service Navi Mumbai"],
    ["Wedding Cab Service Navi Mumbai", "Cheap Cab Service Navi Mumbai"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "24x7 Availability",
      "WhyChoosedescription": "Round-the-clock cab service across Navi Mumbai."
    },
    {
      "WhyChooseheading": "Transparent Taxi Fare",
      "WhyChoosedescription": "Clear billing structure without hidden charges."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Experienced chauffeurs familiar with city routes."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Innova, and luxury vehicles available."
    },
    {
      "WhyChooseheading": "Airport Pickup Support",
      "WhyChoosedescription": "Timely pickup from Mumbai Airport terminals."
    },
    {
      "WhyChooseheading": "Corporate Travel Solutions",
      "WhyChoosedescription": "Reliable transport for business and office needs."
    },
    {
      "WhyChooseheading": "Event & Wedding Travel",
      "WhyChoosedescription": "Spacious vehicles for special occasions."
    },
    {
      "WhyChooseheading": "Safe & Comfortable Travel",
      "WhyChoosedescription": "Well-maintained AC vehicles ensure relaxed rides."
    }
  ]
}











const faqData = [
  {
    question: 'Does Lotus Cab provide cab service in Navi Mumbai?',
    answer: 'Yes, Lotus Cab offers reliable and affordable cab service in Navi Mumbai for local travel, airport transfers, and outstation trips with professional drivers.',
  },
  {
    question: 'Which areas in Navi Mumbai are covered by Lotus Cab?',
    answer: 'Lotus Cab provides cab service across major areas of Navi Mumbai including Vashi, Nerul, Belapur, Airoli, Kharghar, Panvel, Ghansoli, and surrounding locations.',
  },
  {
    question: 'What are the charges for cab service in Navi Mumbai?',
    answer: 'Cab charges depend on distance, trip type (local or outstation), and vehicle category. Lotus Cab maintains transparent per km pricing with no hidden charges.',
  },
  {
    question: 'Is Navi Mumbai airport cab service available?',
    answer: 'Yes, Lotus Cab provides convenient airport pickup and drop services to and from Navi Mumbai International Airport and Mumbai Airport.',
  },
  {
    question: 'Can I book a one-way cab from Navi Mumbai?',
    answer: 'Yes, Lotus Cab offers affordable one-way cab services from Navi Mumbai to destinations like Pune, Nashik, Lonavala, and other cities.',
  },
  {
    question: 'Which vehicles are available for cab booking in Navi Mumbai?',
    answer: 'We provide Sedan cars like Dzire and Etios for comfortable city travel and SUVs like Ertiga and Innova Crysta for group and long-distance travel.',
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll, parking, and applicable taxes are charged separately as per actuals. Lotus Cab ensures complete fare transparency before confirming the booking.',
  },
  {
    question: 'Is night cab service available in Navi Mumbai?',
    answer: 'Yes, Lotus Cab provides safe and secure 24/7 cab service in Navi Mumbai including late-night and early-morning travel.',
  },
  {
    question: 'Can I book a cab for corporate travel in Navi Mumbai?',
    answer: 'Absolutely. Lotus Cab offers punctual and professional cab services for corporate meetings, office transfers, and business travel.',
  },
  {
    question: 'How can I book cab service in Navi Mumbai with Lotus Cab?',
    answer: 'You can book by sharing your pickup location, travel date, time, and vehicle preference to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sagar Patil',
    feedback: 'Booked Lotus Cab for local travel in Navi Mumbai. The driver was punctual and the car was clean. Excellent service and reasonable pricing.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Neha Mehta',
    feedback: 'Very reliable cab service in Navi Mumbai. Smooth airport transfer and transparent fare. Highly recommend Lotus Cab.',
    rating: 5,
  },
];












































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Navi Mumbai",
"image": "https://lotuscab.com/assets/images/cab-service-in-navi-mumbai.jpg",
"description": "Book Cab Service in Navi Mumbai with Lotus Cab for safe, affordable, and reliable local and outstation travel. 24x7 taxi service with Sedan, SUV, and AC cabs, professional drivers, and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "8720"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹10/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/cab-service-in-navi-mumbai"
}
};
















  return (
    <div>
      
<Helmet>
  <title>Cab Service in Navi Mumbai | 24x7 Local & Outstation Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Cab Service in Navi Mumbai with Lotus Cab for affordable local and outstation travel. 24x7 taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and reliable doorstep pickup."
/>

<meta
 name="keywords"
 content="Cab Service in Navi Mumbai, Navi Mumbai Cab Service, Navi Mumbai Taxi Service, Local Cab Navi Mumbai, Outstation Cab Navi Mumbai, Airport Cab Navi Mumbai, Cheap Cab Navi Mumbai, Best Cab Service Navi Mumbai, Online Cab Booking Navi Mumbai, Sedan Cab Navi Mumbai, SUV Cab Navi Mumbai, 24x7 Taxi Navi Mumbai, Affordable Cab Navi Mumbai, Lotus Cab Navi Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/83.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinnavimumbai;